<rask-leverantorsorderrad-create
    [rootForm]="form"
    [order]="order"
    [enableCommands]="false"
    (modelCreated)="onModelCreated($event)"
    (onAdd)="orderradAdded($event)">
</rask-leverantorsorderrad-create>

<div class="buttons">
    <rask-save-button (click)="add()" [disabled]="!canAdd()"></rask-save-button>
</div>
